module.exports = __webpack_public_path__ + "5842af4e2068f12039ee7e35a52e48bc.png";